Cureus.SearchTool = {
  fluxxor: {
    actions: {},
    constants: {},
    stores: {}
  }
};

//= require_tree ./SearchTool
